exports.key = 'ball190808'

// 设置全局变量
const varsPlugin = {
  install(Vue) {
    // 活动key
    Vue.prototype.$key = exports.key
    // 环境变量
    Vue.prototype.$env = process.env.VUE_APP_ENV
    // 不同环境的接口
    const baseURL = {}
    baseURL.cat = `https://${window.location.host}`
    if (process.env.VUE_APP_ENV === 'prod') {
      baseURL.api = 'https://api.pangku.com'
      baseURL.merchant = 'https://merchant.pangku.com'
    } else {
      baseURL.api = 'https://tapi.pangku.com'
      baseURL.merchant = 'https://prem.pangku.com'
    }
    Vue.prototype.$baseURL = baseURL
  }
}

exports.vars = varsPlugin

// 分享文案，图片上传到七牛https://pangku.com/upload/qiniu
// link填cat.pangku.com，自动判断环境
exports.shareDataMain = {
  title: '猜球队瓜分百万现金',
  desc: '点击竞猜球队，快来和我瓜分160万现金吧！',
  link: 'https://cat.pangku.com/dist/ball190808/index.html',
  imgUrl: 'https://a-img.pangku.com/ball190808/oo03rmboln.jpg'
}

// link填cat.pangku.com，自动判断环境
exports.shareDataMinor = {
  title: '赛事互动  赢百万现金红包',
  desc: '一起来参与篮球杯赛事讨论，每天都抽大奖！',
  link: 'https://cat.pangku.com/dist/ball190808/index.html',
  imgUrl: 'https://a-img.pangku.com/ball190808/1b1bfaq3d9j.jpg'
}

// 重新运行才能生效
// 地址相对vue.config.js
exports.pages = {
  index: {
    template: './src/ball190808/base/template.html',
    title: '猜球队瓜分百万现金',
    entry: './src/ball190808/index/index.js',
    filename: 'index.html',
    chunks: ['chunk-vendors', 'chunk-common', 'index']
  },
  game: {
    template: './src/ball190808/base/template.html',
    title: '猜球队瓜分百万现金',
    entry: './src/ball190808/game/game.js',
    filename: 'game.html',
    chunks: ['chunk-vendors', 'chunk-common', 'game']
  },
  minor: {
    template: './src/ball190808/base/template.html',
    title: '猜球队瓜分百万现金',
    entry: './src/ball190808/minor/minor.js',
    filename: 'minor.html',
    chunks: ['chunk-vendors', 'chunk-common', 'minor']
  },
  message: {
    template: './src/ball190808/base/template.html',
    title: '猜球队瓜分百万现金',
    entry: './src/ball190808/message/message.js',
    filename: 'message.html',
    chunks: ['chunk-vendors', 'chunk-common', 'message']
  },
  intention: {
    template: './src/ball190808/base/template.html',
    title: '猜球队瓜分百万现金',
    entry: './src/ball190808/intention/intention.js',
    filename: 'intention.html',
    chunks: ['chunk-vendors', 'chunk-common', 'intention']
  },
  share: {
    template: './src/ball190808/base/template.html',
    title: '猜球队瓜分百万现金',
    entry: './src/ball190808/share/share.js',
    filename: 'share.html',
    chunks: ['chunk-vendors', 'chunk-common', 'share']
  },
  rule: {
    template: './src/ball190808/base/template.html',
    title: '猜球队瓜分百万现金',
    entry: './src/ball190808/rule/rule.js',
    filename: 'rule.html',
    chunks: ['chunk-vendors', 'chunk-common', 'rule']
  },
  minorrule: {
    template: './src/ball190808/base/template.html',
    title: '猜球队瓜分百万现金',
    entry: './src/ball190808/minorrule/minorrule.js',
    filename: 'minorrule.html',
    chunks: ['chunk-vendors', 'chunk-common', 'minorrule']
  }
}

// 前端、后端和设计
exports.author = {
  frontend: '***',
  backend: '***',
  designer: '***'
}
